import React, { Component } from "react";
import {
  MdClose,
  MdDoneAll,
  MdArchive,
  MdInput,
  MdExpandMore,
  MdInfo
} from "react-icons/md";
import arrayToObj from "./array_to_obj";
import Moment from "react-moment";
import Swal from "sweetalert2";
import swal from "@sweetalert/with-react";
import showInfo from "./show_info";
import io from "socket.io-client";
const url = "https://transacoes-api.all.com.br:3080";
const statusItem = require("../status.json");
const uuidv4 = require("uuid/v4");

let filterTransaction = [],
  selectedMovements = [],
  itemsAdded = [],
  checkboxIdSameTransaction = "";

class TransactionsValidation extends Component {
  state = {
    statusChangeItem: false,
    statusChangeTransaction: false,
    recipient: "",
    report: "",
    thisTransaction: 0,
    onlyArchive: false,
    filter: "",
    thisFilter: "",
    thisSearchValue: ""
  };

  async componentDidMount() {
    await this.setState({
      thisFilter: this.props.filter,
      thisSearchValue: this.props.searchValue
    });
  }

  socket = io(url);

  async componentWillReceiveProps() {
    if (
      this.state.thisFilter !== this.props.filter ||
      this.state.thisSearchValue !== this.props.searchValue
    )
      await this.setState({ thisTransaction: 0 });
    await this.setState({ filter: this.props.filter });
    selectedMovements.splice(0, selectedMovements.length);
  }

  //choosing some action
  handleAction = movement => {
    let filterItem = [];
    filterItem = this.props.items.filter(
      item => item.id_movimentacao === movement.id_movimentacao
    );
    if (
      filterItem[0].status === 1 ||
      filterItem[0].status === 2 ||
      filterItem[0].status === 3
    ) {
      Swal.fire({
        confirmButtonText: "Fechar",
        title: "Gerência - Itens",
        html:
          `<center><h4>Selecione a operação desejada:</h4><br/><button id="status" class="btn btn-secondary"><strong>Atualizar status - Item</strong></button>` +
          "<br/>" +
          "<br/>" +
          `<button id="recipient" class="btn btn-secondary"><strong>Atualizar Destinatário</strong></button></center>` +
          "<br/>" +
          `<button id="report" class="btn btn-danger"><strong>Relatar Erro - Item</strong></button></center>`,
        onBeforeOpen: () => {
          const content = Swal.getContent();
          const buttons = content.querySelector.bind(content);
          const status = buttons("#status");
          const recipient = buttons("#recipient");
          const report = buttons("#report");
          status.addEventListener("click", () => {
            this.changeStatusItem(movement, filterItem[0].status);
            Swal.close();
          });
          recipient.addEventListener("click", () => {
            this.handleRegisterNewMovement(filterItem, movement);
          });
          report.addEventListener("click", () => {
            this.handleReport(filterItem, movement);
          });
        }
      });
    } else {
      swal({
        content: (
          <div>
            <center>
              <h5>Item cancelado ou arquivado!</h5>
            </center>
          </div>
        ),
        icon: "warning"
      });
    }
  };

  //choosing a new item's status
  changeStatusItem = (movement, itemStatus) => {
    //set new item's status to received or canceled
    const setStatus = (status, movement) => {
      swal({
        buttons: true,
        title: `Confirma operação?`
      }).then(willConfirm =>
        willConfirm
          ? this.handleChangeStatusItem(status, movement)
          : swal({ text: "Operação cancelada!" })
      );
    };
    swal({
      buttons: {
        cancel: "Cancelar"
      },
      title: "Alterar Status - Item",
      content: (
        <div
          style={{
            display: "block",
            paddingRight: "50px",
            paddingLeft: "50px"
          }}
        >
          <center>
            <h5>Selecione um novo status clicando no ícone designado:</h5>
          </center>
          <br />
          {this.props.filter === "requester" && (
            <React.Fragment>
              {itemStatus === 1 && (
                <div className="row">
                  <div className="col s6">
                    <label htmlFor="cancelado">CANCELADO:</label>
                  </div>
                  <div className="col s6">
                    <button className="btn btn-danger">
                      <MdClose
                        style={{ fontSize: "1.5rem" }}
                        name="cancelado"
                        rating={1}
                        onClick={() => setStatus(4, movement)}
                      />
                    </button>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col s6">
                  <label htmlFor="arquivado">ARQUIVADO:</label>
                </div>
                <div className="col s6">
                  <button className="btn btn-secondary">
                    <MdArchive
                      style={{ fontSize: "1.5rem" }}
                      name="arquivado"
                      rating={1}
                      onClick={() => setStatus(5, movement)}
                    />
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
          {this.props.filter === "requested" &&
            (itemStatus === 1 || itemStatus === 2 ? (
              <React.Fragment>
                <div className="row">
                  <div className="col s6">
                    <label htmlFor="recebido">RECEBIDO:</label>
                  </div>
                  <div className="col s6">
                    <button className="btn btn-success">
                      <MdDoneAll
                        style={{ fontSize: "1.5rem" }}
                        name="recebido"
                        rating={1}
                        onClick={() => setStatus(3, movement)}
                      />
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col s6">
                    <label htmlFor="arquivado">ARQUIVADO:</label>
                  </div>
                  <div className="col s6">
                    <button className="btn btn-secondary">
                      <MdArchive
                        style={{ fontSize: "1.5rem" }}
                        name="arquivado"
                        rating={1}
                        onClick={() => setStatus(5, movement)}
                      />
                    </button>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <div className="row">
                <div className="col s6">
                  <label htmlFor="arquivado">ARQUIVADO:</label>
                </div>
                <div className="col s6">
                  <button className="btn btn-secondary">
                    <MdArchive
                      style={{ fontSize: "1.5rem" }}
                      name="arquivado"
                      rating={1}
                      onClick={() => setStatus(5, movement)}
                    />
                  </button>
                </div>
              </div>
            ))}
        </div>
      )
    });
  };

  //save new item's status to received or canceled
  handleChangeStatusItem = (status, movement) => {
    Swal.fire({
      title: "Alterando status...",
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
    fetch(`${url}/validacao/item/status`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        userEmail: this.props.userEmail !== "" ? this.props.userEmail : "",
        movement: movement,
        newStatus: status,
        token: JSON.parse(localStorage.getItem("token").toString()).token
      })
    }).then(response => {
      if (response.status !== 200) {
        Swal.close();
        swal({
          title: "Operação falhou!",
          text: "Erro na requisição.",
          icon: "error"
        });
      } else {
        Swal.close();
        this.setState({ statusChangeItem: true });
        swal("Status do item alterado!", { icon: "success" }).then(() => {
          window.location.reload();
          this.socket.emit("data");
        });
      }
    });
  };

  //register new movement && new recipient
  handleRegisterNewMovement = (item, movement) => {
    Swal.fire({
      title: "Cadastro de Novo Destinatário",
      focusConfirm: true,
      focusCancel: false,
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      input: "select",
      inputPlaceholder: "Destinatário...",
      inputOptions: arrayToObj(
        this.props.employees,
        item[0].destino,
        movement.id_remetente
      ),
      preConfirm: () => {
        if (document.getElementsByClassName("swal2-select")[0].value !== "")
          this.setState({
            recipient: document.getElementsByClassName("swal2-select")[0].value
          });
        else
          this.setState({
            recipient: ""
          });
      }
    }).then(willCancel =>
      willCancel.dismiss === "cancel"
        ? false
        : willCancel.value !== ""
        ? this.state.recipient !== "" &&
          Swal.fire({
            title: "Cadastrando...",
            onBeforeOpen: () => {
              Swal.showLoading();
            }
          })
          ? fetch(`${url}/validacao/movimentacao/interceptador`, {
              method: "post",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                idEmployeeLogged:
                  this.props.idEmployeeLogged !== ""
                    ? this.props.idEmployeeLogged
                    : "",
                movement: movement,
                newRecipient: this.state.recipient,
                token: JSON.parse(localStorage.getItem("token").toString())
                  .token
              })
            }).then(response => {
              if (response.status === 406) {
                Swal.close();
                swal({
                  title: "Operação falhou!",
                  content: (
                    <div>
                      <center>
                        <h5>
                          O remetente não pode ser cadastrado como destinatário!
                        </h5>
                      </center>
                    </div>
                  ),
                  icon: "error"
                });
              } else {
                Swal.close();
                swal(`Novo destinatário cadastrado!`, {
                  icon: "success"
                }).then(() => {
                  window.location.reload();
                  this.socket.emit("data");
                });
              }
            })
          : swal("Destinatário não selecionado!")
        : swal("Destinatário não selecionado!")
    );
  };

  getReport = async item => {
    await fetch(`${url}/validacao/item/observacao`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        idEmployeeLogged:
          this.props.idEmployeeLogged !== "" ? this.props.idEmployeeLogged : "",
        item: item,
        token: JSON.parse(localStorage.getItem("token").toString()).token
      })
    })
      .then(response => response.json())
      .then(async report => {
        if (report !== null) {
          await this.setState({ report });
        } else {
          await this.setState({ report: "" });
        }
      });
  };

  handleReport = async (item, movement) => {
    await this.getReport(item);
    Swal.fire({
      onOpen: () => {
        document.getElementsByClassName(
          "swal2-textarea"
        )[0].value = this.state.report;
      },
      title: "Envio Incorreto do Item",
      text: "Por favor, informe o erro ocorrido:",
      focusConfirm: true,
      focusCancel: false,
      showCancelButton: true,
      showConfirmButton: true,
      reverseButtons: true,
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
      input: "textarea",
      inputAttributes: {
        maxlength: 500
      },
      inputPlaceholder: "Assunto...",
      preConfirm: () => {
        if (document.getElementsByClassName("swal2-textarea")[0].value !== "")
          this.setState({
            report: document.getElementsByClassName("swal2-textarea")[0].value
          });
        else
          this.setState({
            report: ""
          });
      }
    }).then(willCancel =>
      willCancel.dismiss === "cancel"
        ? false
        : willCancel.value !== ""
        ? this.state.report !== "" &&
          Swal.fire({
            title: "Enviando...",
            onBeforeOpen: () => {
              Swal.showLoading();
            }
          })
          ? fetch(`${url}/validacao/item/erro`, {
              method: "post",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                idEmployeeLogged:
                  this.props.idEmployeeLogged !== ""
                    ? this.props.idEmployeeLogged
                    : "",
                item: item,
                movement: movement,
                report: this.state.report,
                token: JSON.parse(localStorage.getItem("token").toString())
                  .token
              })
            }).then(response => {
              if (response.status === 400) {
                Swal.close();
                swal({
                  title: "Operação falhou!",
                  content: (
                    <div>
                      <center>
                        <h5>Erro ao registrar!</h5>
                      </center>
                    </div>
                  ),
                  icon: "error"
                });
              } else {
                Swal.close();
                swal(`Observação registrada com sucesso!`, {
                  icon: "success"
                }).then(() => {
                  window.location.reload();
                  this.socket.emit("data");
                });
              }
            })
          : swal("Nenhuma observação registrada!")
        : swal("Nenhuma observação registrada!")
    );
  };

  //change transaction's status to concluded
  handleChangeStatusTransaction = transaction => {
    swal({
      title: "Concluir malote?",
      buttons: { cancel: "Cancelar", ok: "Concluir" }
    }).then(willConfirm => {
      if (willConfirm) {
        Swal.fire({
          title: "Concluindo malote...",
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });
        fetch(`${url}/validacao/transacoes/status`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            userEmail: this.props.userEmail !== "" ? this.props.userEmail : "",
            transaction,
            token: JSON.parse(localStorage.getItem("token").toString()).token
          })
        }).then(response => {
          if (response.status === 304) {
            Swal.close();
            swal({
              title: "Operação falhou!",
              content: (
                <div>
                  <center>
                    <h5>
                      Itens pendentes ou não verificados neste malote!
                      Conclua-os para finalizá-lo.
                    </h5>
                  </center>
                </div>
              ),
              icon: "error"
            });
          } else if (response.status === 406) {
            Swal.close();
            this.setState({ statusChangeTransaction: false });
            swal("Malote pode ser concluído apenas pelo remetente!", {
              icon: "error"
            });
          } else {
            Swal.close();
            this.setState({ statusChangeTransaction: true });
            swal("Malote concluído!", { icon: "success" }).then(() => {
              window.location.reload();
              this.socket.emit("data");
            });
          }
        });
      }
    });
  };

  //set unique id per transaction
  setUuidv4 = () => {
    checkboxIdSameTransaction = uuidv4();
  };

  //check all items/movements per transaction
  selectAllMovements = (e, transaction) => {
    if (this.state.thisTransaction === 0) {
      this.setState({ thisTransaction: transaction.id_transacao });
      if (e.target.checked) {
        Array.from(document.querySelectorAll("input")).filter(input => {
          if (input.id.includes(e.target.id))
            return (
              !document.getElementById(input.id).checked &&
              document.getElementById(input.id).click()
            );
          else return false;
        });
        if (selectedMovements.length === 0) e.target.checked = false;
      } else {
        Array.from(document.querySelectorAll("input")).filter(input => {
          if (input.id.includes(e.target.id))
            return (
              document.getElementById(input.id).checked &&
              document.getElementById(input.id).click()
            );
          else return false;
        });
      }
    } else if (this.state.thisTransaction === transaction.id_transacao) {
      if (e.target.checked) {
        Array.from(document.querySelectorAll("input")).filter(input => {
          if (input.id.includes(e.target.id))
            return (
              !document.getElementById(input.id).checked &&
              document.getElementById(input.id).click()
            );
          else return false;
        });
        if (selectedMovements.length === 0) e.target.checked = false;
      } else {
        Array.from(document.querySelectorAll("input")).filter(input => {
          if (input.id.includes(e.target.id))
            return (
              document.getElementById(input.id).checked &&
              document.getElementById(input.id).click()
            );
          else return false;
        });
      }
    } else {
      e.target.checked = false;
      swal({
        title: "Seleção incorreta!",
        content: (
          <div>
            <center>
              <h5>Outro malote já foi selecionado!</h5>
            </center>
          </div>
        ),
        icon: "warning"
      });
    }
    if (selectedMovements.length === 0) {
      this.setState({ thisTransaction: 0, onlyArchive: false });
    }
  };

  //select movement && item
  selectMovements = (e, item, movement, transaction) => {
    let countMovements = this.props.movements.filter(
      movement =>
        movement.id_transacao === transaction.id_transacao &&
        movement.status.toLowerCase() === "ativa"
    );
    if (this.state.thisTransaction === 0) {
      this.setState({ thisTransaction: transaction.id_transacao });
      if (e.target.checked) {
        if (
          (item.status === 3 && this.props.filter === "requested") ||
          (item.status !== 1 && this.props.filter === "requester")
        ) {
          this.setState({ onlyArchive: true });
          selectedMovements.push(movement);
          itemsAdded.push(item);
        } else {
          selectedMovements.push(movement);
          itemsAdded.push(item);
        }
        if (countMovements.length === selectedMovements.length) {
          Array.from(document.querySelectorAll("input")).filter(input => {
            if (document.getElementById(input.id) !== null) {
              if (e.target.id.includes(input.id))
                return (
                  document.getElementById(e.target.id).checked &&
                  !document.getElementById(input.id).checked &&
                  document.getElementById(input.id).click()
                );
              else return false;
            } else return false;
          });
        }
      } else {
        if (selectedMovements.length === 1) {
          Array.from(document.querySelectorAll("input")).filter(input => {
            if (document.getElementById(input.id) !== null) {
              if (e.target.id.includes(input.id))
                return (
                  !document.getElementById(e.target.id).checked &&
                  document.getElementById(input.id).checked &&
                  document.getElementById(input.id).click()
                );
              else return false;
            } else return false;
          });
        }
        selectedMovements = selectedMovements.filter(function(obj) {
          return obj.id_movimentacao !== movement.id_movimentacao;
        });
        itemsAdded = itemsAdded.filter(function(obj) {
          return obj.id_item !== item.id_item;
        });
        let itemsReceived = itemsAdded.filter(item => item.status === 3);
        if (
          itemsReceived.length === 0 &&
          ((item.status === 3 && this.props.filter === "requested") ||
            (item.status !== 1 && this.props.filter === "requester"))
        )
          this.setState({ onlyArchive: false });
      }
    } else if (this.state.thisTransaction === transaction.id_transacao) {
      if (e.target.checked) {
        if (
          (item.status === 3 && this.props.filter === "requested") ||
          (item.status !== 1 && this.props.filter === "requester")
        ) {
          this.setState({ onlyArchive: true });
          selectedMovements.push(movement);
          itemsAdded.push(item);
        } else {
          selectedMovements.push(movement);
          itemsAdded.push(item);
        }
        if (countMovements.length === selectedMovements.length) {
          Array.from(document.querySelectorAll("input")).filter(input => {
            if (document.getElementById(input.id) !== null) {
              if (e.target.id.includes(input.id))
                return (
                  document.getElementById(e.target.id).checked &&
                  !document.getElementById(input.id).checked &&
                  document.getElementById(input.id).click()
                );
              else return false;
            } else return false;
          });
        }
      } else {
        if (selectedMovements.length === 1) {
          Array.from(document.querySelectorAll("input")).filter(input => {
            if (document.getElementById(input.id) !== null) {
              if (e.target.id.includes(input.id))
                return (
                  !document.getElementById(e.target.id).checked &&
                  document.getElementById(input.id).checked &&
                  document.getElementById(input.id).click()
                );
              else return false;
            } else return false;
          });
        }
        selectedMovements = selectedMovements.filter(function(obj) {
          return obj.id_movimentacao !== movement.id_movimentacao;
        });
        itemsAdded = itemsAdded.filter(function(obj) {
          return obj.id_item !== item.id_item;
        });
        let itemsReceived = itemsAdded.filter(item => item.status === 3);
        if (
          itemsReceived.length === 0 &&
          ((item.status === 3 && this.props.filter === "requested") ||
            (item.status !== 1 && this.props.filter === "requester"))
        )
          this.setState({ onlyArchive: false });
      }
    } else {
      e.target.checked = false;
      swal({
        title: "Seleção incorreta!",
        content: (
          <div>
            <center>
              <h5>Os itens selecionados devem pertencer ao mesmo malote!</h5>
            </center>
          </div>
        ),
        icon: "warning"
      });
    }
    if (selectedMovements.length === 0) {
      this.setState({ thisTransaction: 0, onlyArchive: false });
    }
  };

  //handle change status (selected items)
  handleChangeStatusSelectedItems = transaction => {
    if (transaction && selectedMovements.length > 0) {
      let filterMovements = selectedMovements.filter(
        movement => movement.id_transacao === transaction.id_transacao
      );
      if (filterMovements.length === selectedMovements.length) {
        let setStatus = status => {
          swal({
            buttons: true,
            title: `Confirma operação?`
          }).then(willConfirm =>
            willConfirm
              ? selectedMovements.map(movement =>
                  this.handleChangeStatusItem(status, movement)
                )
              : swal({ text: "Operação cancelada!" })
          );
        };
        swal({
          buttons: {
            cancel: "Cancelar"
          },
          title: "Alterar Status - Itens",
          content: (
            <div
              style={{
                display: "block",
                paddingRight: "50px",
                paddingLeft: "50px"
              }}
            >
              <center>
                <h5>Confirme a alteração clicando no ícone designado:</h5>
              </center>
              <br />
              {this.props.filter === "requester" && (
                <React.Fragment>
                  {this.state.onlyArchive === false && (
                    <div className="row">
                      <div className="col s6">
                        <label htmlFor="cancelado">CANCELADO:</label>
                      </div>
                      <div className="col s6">
                        <button className="btn btn-danger">
                          <MdClose
                            style={{ fontSize: "1.5rem" }}
                            name="cancelado"
                            rating={1}
                            onClick={() => setStatus(4)}
                          />
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col s6">
                      <label htmlFor="arquivado">ARQUIVADO:</label>
                    </div>
                    <div className="col s6">
                      <button className="btn btn-secondary">
                        <MdArchive
                          style={{ fontSize: "1.5rem" }}
                          name="arquivado"
                          rating={1}
                          onClick={() => setStatus(5)}
                        />
                      </button>
                    </div>
                  </div>
                </React.Fragment>
              )}
              {this.props.filter === "requested" && (
                <React.Fragment>
                  {this.state.onlyArchive === false && (
                    <div className="row">
                      <div className="col s6">
                        <label htmlFor="recebido">RECEBIDO:</label>
                      </div>
                      <div className="col s6">
                        <button className="btn btn-success">
                          <MdDoneAll
                            style={{ fontSize: "1.5rem" }}
                            name="recebido"
                            rating={1}
                            onClick={() => setStatus(3)}
                          />
                        </button>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col s6">
                      <label htmlFor="arquivado">ARQUIVADO:</label>
                    </div>
                    <div className="col s6">
                      <button className="btn btn-secondary">
                        <MdArchive
                          style={{ fontSize: "1.5rem" }}
                          name="arquivado"
                          rating={1}
                          onClick={() => setStatus(5)}
                        />
                      </button>
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
          )
        });
      } else
        swal({
          title: "Seleção incorreta!",
          content: (
            <div>
              <center>
                <h5>Os itens selecionados devem pertencer ao mesmo malote!</h5>
              </center>
            </div>
          ),
          icon: "warning"
        });
    } else {
      swal({
        content: (
          <div>
            <center>
              <h5>Itens não selecionados!</h5>
            </center>
          </div>
        ),
        icon: "warning"
      });
    }
  };

  render() {
    const {
      selectedContentTransaction,
      transactions,
      movements,
      items,
      employees,
      filter
    } = this.props;
    return (
      <React.Fragment>
        <div className="container">
          <div
            className="transaction-content-validation"
            style={{ marginTop: "195px" }}
          >
            <div
              className="card-panel white lighten-5 z-depth-1"
              style={{
                width: "100%",
                margin: "auto",
                height: "auto",
                display: "block",
                position: "relative",
                boxShadow:
                  "0 2px 5px rgba(0, 0, 0, 0.12), 0 2px 5px rgba(0, 0, 0, 0.24)",
                fontSize: "1.1rem",
                marginTop: "40px"
              }}
            >
              {selectedContentTransaction.length > 0 ? (
                selectedContentTransaction
                  .filter(
                    selectTransaction =>
                      selectTransaction.status
                        .toLowerCase()
                        .includes("ativa") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("pendente") ||
                      selectTransaction.status
                        .toLowerCase()
                        .includes("concluida")
                  )
                  .map((transaction, i) => {
                    this.setUuidv4();
                    return (
                      <React.Fragment key={i}>
                        <div
                          className="accordion md-accordion accordion-blocks"
                          id="accordionEx78"
                          role="tablist"
                          aria-multiselectable="true"
                          style={{
                            alignContent: "left",
                            backgroundColor: "white",
                            display: "block",
                            margin: "auto"
                          }}
                        >
                          <div className="card white" id={"card" + i}>
                            <div
                              className="card-header"
                              role="tab"
                              id={"headingUnfiled" + i}
                              style={
                                transaction.status
                                  .toLowerCase()
                                  .includes("ativa")
                                  ? {
                                      backgroundColor: "#357ae8"
                                    }
                                  : transaction.status
                                      .toLowerCase()
                                      .includes("pendente")
                                  ? {
                                      backgroundColor: "#ff6347"
                                    }
                                  : {
                                      backgroundColor: "#343a40"
                                    }
                              }
                            >
                              <a
                                data-toggle="collapse"
                                data-parent={"#card" + i}
                                href={"#collapseUnfiled" + i}
                                aria-expanded="true"
                                aria-controls="collapseUnfiled"
                              >
                                <h5 className="mt-4 mb-0">
                                  <span style={{ color: "white" }}>
                                    Malote
                                    {transaction.status
                                      .toLowerCase()
                                      .includes("ativa") ? (
                                      <i> - Ativo</i>
                                    ) : transaction.status
                                        .toLowerCase()
                                        .includes("pendente") ? (
                                      <i> - Pendente</i>
                                    ) : (
                                      transaction.status
                                        .toLowerCase()
                                        .includes("concluida") && (
                                        <i> - Concluído</i>
                                      )
                                    )}
                                    <p
                                      className="left"
                                      style={{ color: "white" }}
                                    >
                                      ID: {transaction.id_transacao}
                                    </p>
                                    <p
                                      className="right"
                                      style={{ color: "white" }}
                                    >
                                      <MdExpandMore />
                                    </p>
                                    {transaction.status === "concluida" && (
                                      <p
                                        className="right"
                                        style={{ fontSize: "0.7rem" }}
                                      >
                                        <Moment
                                          fromNow
                                          ago
                                          add={{ hours: 3 }}
                                          titleFormat="D MMM YYYY"
                                          withTitle
                                        >
                                          {transaction.updated_at}
                                        </Moment>
                                      </p>
                                    )}
                                  </span>
                                </h5>
                              </a>
                            </div>
                            <div
                              id={"collapseUnfiled" + i}
                              className="collapse show"
                              role="tabpanel"
                              aria-labelledby={"headingUnfiled" + i}
                              data-parent={"#card" + i}
                            >
                              <div className="card-body">
                                <React.Fragment>
                                  <div
                                    className="row justify-content-center"
                                    style={{
                                      display: "block",
                                      margin: "auto",
                                      width: "100%"
                                    }}
                                  >
                                    <div className="col s12">
                                      {movements.length > 0 ? (
                                        <React.Fragment>
                                          <table className="table table-responsive table-sm table-hover">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  ID Movimentação
                                                </th>
                                                <th scope="col">Remetente</th>
                                                <th scope="col">
                                                  Destinatário
                                                </th>
                                                <th scope="col">Modificado</th>
                                                <th scope="col">Horário</th>
                                                <th scope="col">ID Item</th>
                                                <th scope="col">Tipo</th>
                                                <th scope="col">Descrição</th>
                                                <th scope="col">
                                                  Código/Patrimônio
                                                </th>
                                                <th scope="col">Observação</th>
                                                <th scope="col">
                                                  <i>Status</i>
                                                </th>
                                                <th scope="col">Ações</th>
                                                <th scope="col">
                                                  <input
                                                    disabled={
                                                      transaction.status ===
                                                      "concluida"
                                                        ? true
                                                        : false
                                                    }
                                                    defaultChecked={false}
                                                    type="checkbox"
                                                    id={
                                                      "status" +
                                                      checkboxIdSameTransaction
                                                    }
                                                    onChange={e =>
                                                      this.selectAllMovements(
                                                        e,
                                                        transaction
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={
                                                      "status" +
                                                      checkboxIdSameTransaction
                                                    }
                                                  />
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {movements
                                                .filter(
                                                  movement =>
                                                    movement.id_transacao ===
                                                    transaction.id_transacao
                                                )
                                                .map((movement, j) =>
                                                  movement.status ===
                                                  "ativa" ? (
                                                    <tr key={j}>
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {
                                                          movement.id_movimentacao
                                                        }
                                                      </td>
                                                      {employees.length > 0 &&
                                                        employees
                                                          .filter(
                                                            employee =>
                                                              employee.id ===
                                                              movement.id_remetente
                                                          )
                                                          .map(
                                                            (employee, l) => (
                                                              <td key={l}>
                                                                {employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )}
                                                              </td>
                                                            )
                                                          )}
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <Moment format="DD/MM/YYYY">
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td>
                                                        <Moment
                                                          add={{ hours: 3 }}
                                                          format="HH:mm:ss"
                                                        >
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      {items.length > 0 &&
                                                        items
                                                          .filter(
                                                            item =>
                                                              item.id_movimentacao ===
                                                              movement.id_movimentacao
                                                          )
                                                          .map((item, k) => (
                                                            <React.Fragment
                                                              key={k}
                                                            >
                                                              <td
                                                                style={{
                                                                  fontWeight:
                                                                    "bolder"
                                                                }}
                                                              >
                                                                {item.id_item}
                                                              </td>
                                                              <td>
                                                                {item.tipo.toUpperCase()}
                                                              </td>
                                                              <td>
                                                                {item.descricao &&
                                                                  (item
                                                                    .descricao
                                                                    .length <=
                                                                  15 ? (
                                                                    item.descricao
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_descricao"
                                                                      maxLength="100"
                                                                      value={
                                                                        item.descricao
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  ))}
                                                              </td>
                                                              <td>
                                                                {item.patrimonio ? (
                                                                  item
                                                                    .patrimonio
                                                                    .length <=
                                                                  15 ? (
                                                                    item.patrimonio
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_patrimonio"
                                                                      maxLength="30"
                                                                      value={
                                                                        item.patrimonio
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  )
                                                                ) : (
                                                                  "----"
                                                                )}
                                                              </td>
                                                              <td>
                                                                {item.observacao ? (
                                                                  item
                                                                    .observacao
                                                                    .length <=
                                                                  15 ? (
                                                                    item.observacao
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_observacao"
                                                                      maxLength="1000"
                                                                      value={
                                                                        item.observacao
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  )
                                                                ) : (
                                                                  "----"
                                                                )}
                                                              </td>
                                                              <td>
                                                                {statusItem
                                                                  .filter(
                                                                    status =>
                                                                      status.id_status ===
                                                                      item.status
                                                                  )
                                                                  .map(
                                                                    (
                                                                      status,
                                                                      l
                                                                    ) => (
                                                                      <i
                                                                        key={l}
                                                                        style={
                                                                          item.status ===
                                                                          4
                                                                            ? {
                                                                                color:
                                                                                  "red"
                                                                              }
                                                                            : item.status ===
                                                                              3
                                                                            ? {
                                                                                color:
                                                                                  "green"
                                                                              }
                                                                            : item.status ===
                                                                              2
                                                                            ? {
                                                                                color:
                                                                                  "tomato"
                                                                              }
                                                                            : item.status ===
                                                                              1
                                                                            ? {
                                                                                color:
                                                                                  "#357ae8"
                                                                              }
                                                                            : {
                                                                                color:
                                                                                  "black"
                                                                              }
                                                                        }
                                                                      >
                                                                        {status.status.toUpperCase()}
                                                                      </i>
                                                                    )
                                                                  )}
                                                              </td>
                                                              <td align="center">
                                                                <MdInput
                                                                  style={{
                                                                    paddingRight:
                                                                      "5px",
                                                                    fontSize:
                                                                      "1.3rem"
                                                                  }}
                                                                  onClick={() =>
                                                                    !transaction.status.includes(
                                                                      "concluida"
                                                                    ) &&
                                                                    this.handleAction(
                                                                      movement
                                                                    )
                                                                  }
                                                                />
                                                                <MdInfo
                                                                  style={{
                                                                    paddingLeft:
                                                                      "5px",
                                                                    fontSize:
                                                                      "1.3rem"
                                                                  }}
                                                                  onClick={() =>
                                                                    showInfo(
                                                                      item
                                                                    )
                                                                  }
                                                                />
                                                              </td>
                                                              {item.status !==
                                                                5 &&
                                                              item.status !==
                                                                4 ? (
                                                                <td align="center">
                                                                  <input
                                                                    disabled={
                                                                      filter ===
                                                                      "requester"
                                                                        ? item.status !==
                                                                            5 &&
                                                                          item.status !==
                                                                            4
                                                                          ? false
                                                                          : true
                                                                        : item.status !==
                                                                          5
                                                                        ? false
                                                                        : true
                                                                    }
                                                                    defaultChecked={
                                                                      false
                                                                    }
                                                                    type="checkbox"
                                                                    id={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                    onChange={e =>
                                                                      this.selectMovements(
                                                                        e,
                                                                        item,
                                                                        movement,
                                                                        transaction
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    htmlFor={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                  />
                                                                </td>
                                                              ) : (
                                                                <td align="center">
                                                                  <input
                                                                    disabled={
                                                                      true
                                                                    }
                                                                    defaultChecked={
                                                                      false
                                                                    }
                                                                    type="checkbox"
                                                                    id={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                    onChange={e =>
                                                                      this.selectMovements(
                                                                        e,
                                                                        item,
                                                                        movement,
                                                                        transaction
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    htmlFor={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                  />
                                                                </td>
                                                              )}
                                                            </React.Fragment>
                                                          ))}
                                                    </tr>
                                                  ) : (
                                                    <tr
                                                      key={j}
                                                      style={{
                                                        backgroundColor:
                                                          "#fafafa"
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {
                                                          movement.id_movimentacao
                                                        }
                                                      </td>
                                                      {employees.length > 0 &&
                                                        employees
                                                          .filter(
                                                            employee =>
                                                              employee.id ===
                                                              movement.id_remetente
                                                          )
                                                          .map(
                                                            (employee, l) => (
                                                              <td key={l}>
                                                                {employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )}
                                                              </td>
                                                            )
                                                          )}
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <Moment format="DD/MM/YYYY">
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td>
                                                        <Moment
                                                          add={{ hours: 3 }}
                                                          format="HH:mm:ss"
                                                        >
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td>
                                                        {movement.id_item}
                                                      </td>
                                                      <td>
                                                        <i>Interceptado por:</i>
                                                      </td>
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_interceptador
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <i>
                                                          Novo destinatário:
                                                        </i>
                                                      </td>
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_novo_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <i>Recebido por: </i>
                                                      </td>
                                                      {movement.id_destinatario_item_recebido ? (
                                                        <td>
                                                          {employees.length >
                                                            0 &&
                                                            employees
                                                              .filter(
                                                                employee =>
                                                                  employee.id ===
                                                                  movement.id_destinatario_item_recebido
                                                              )
                                                              .map(employee =>
                                                                employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )
                                                              )}
                                                        </td>
                                                      ) : (
                                                        <td align="center">
                                                          ----
                                                        </td>
                                                      )}
                                                      <td align="center">
                                                        ----
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                          <div
                                            className="modal-footer"
                                            style={{
                                              padding: "none",
                                              borderTop: "none",
                                              display: "flex",
                                              WebkitBoxAlign: "center",
                                              justifyContent: "flex-end"
                                            }}
                                          >
                                            {!transaction.status.includes(
                                              "concluida"
                                            ) && (
                                              <React.Fragment>
                                                <div className="row">
                                                  <div
                                                    className="col s6"
                                                    style={{ padding: "5px" }}
                                                  >
                                                    <button
                                                      className="btn btn-secondary"
                                                      onClick={() =>
                                                        this.handleChangeStatusSelectedItems(
                                                          transaction
                                                        )
                                                      }
                                                    >
                                                      Seleção
                                                    </button>
                                                  </div>
                                                  {filter === "requester" && (
                                                    <div
                                                      className="col s6"
                                                      style={{
                                                        padding: "5px"
                                                      }}
                                                      hidden={true}
                                                    >
                                                      <button
                                                        className="btn right"
                                                        onClick={() =>
                                                          this.handleChangeStatusTransaction(
                                                            transaction
                                                          )
                                                        }
                                                        style={
                                                          transaction.status
                                                            .toLowerCase()
                                                            .includes("ativa")
                                                            ? {
                                                                backgroundColor:
                                                                  "#357ae8"
                                                              }
                                                            : transaction.status
                                                                .toLowerCase()
                                                                .includes(
                                                                  "pendente"
                                                                ) && {
                                                                backgroundColor:
                                                                  "#ff6347"
                                                              }
                                                        }
                                                      >
                                                        Concluir
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              </React.Fragment>
                                            )}
                                          </div>
                                        </React.Fragment>
                                      ) : (
                                        <p style={{ paddingTop: "25px" }}>
                                          Não há novos registros.
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
              ) : selectedContentTransaction && transactions.length > 0 ? (
                ((filterTransaction = transactions.filter(
                  selectTransaction =>
                    selectTransaction.status.toLowerCase().includes("ativa") ||
                    selectTransaction.status
                      .toLowerCase()
                      .includes("pendente") ||
                    selectTransaction.status.toLowerCase().includes("concluida")
                )),
                filterTransaction.length > 0 ? (
                  filterTransaction.map((transaction, i) => {
                    this.setUuidv4();
                    return (
                      <React.Fragment key={i}>
                        <div
                          className="accordion md-accordion accordion-blocks"
                          id="accordionEx78"
                          role="tablist"
                          aria-multiselectable="true"
                          style={{
                            alignContent: "left"
                          }}
                        >
                          <div className="card white" id={"card" + i}>
                            <div
                              className="card-header"
                              role="tab"
                              id={"headingUnfiled" + i}
                              style={
                                transaction.status
                                  .toLowerCase()
                                  .includes("ativa")
                                  ? {
                                      backgroundColor: "#357ae8"
                                    }
                                  : transaction.status
                                      .toLowerCase()
                                      .includes("pendente")
                                  ? {
                                      backgroundColor: "#ff6347"
                                    }
                                  : {
                                      backgroundColor: "#343a40"
                                    }
                              }
                            >
                              <a
                                data-toggle="collapse"
                                data-parent={"#card" + i}
                                href={"#collapseUnfiled" + i}
                                aria-expanded="true"
                                aria-controls="collapseUnfiled"
                              >
                                <h5 className="mt-4 mb-0">
                                  <span style={{ color: "white" }}>
                                    Malote
                                    {transaction.status
                                      .toLowerCase()
                                      .includes("ativa") ? (
                                      <i> - Ativo</i>
                                    ) : transaction.status
                                        .toLowerCase()
                                        .includes("pendente") ? (
                                      <i> - Pendente</i>
                                    ) : (
                                      transaction.status
                                        .toLowerCase()
                                        .includes("concluida") && (
                                        <i> - Concluído</i>
                                      )
                                    )}
                                    <p
                                      className="left"
                                      style={{ color: "white" }}
                                    >
                                      ID: {transaction.id_transacao}
                                    </p>
                                    <p
                                      className="right"
                                      style={{ color: "white" }}
                                    >
                                      <MdExpandMore />
                                    </p>
                                    {transaction.status === "concluida" && (
                                      <p
                                        className="right"
                                        style={{ fontSize: "0.7rem" }}
                                      >
                                        <Moment
                                          fromNow
                                          ago
                                          add={{ hours: 3 }}
                                          titleFormat="D MMM YYYY"
                                          withTitle
                                        >
                                          {transaction.updated_at}
                                        </Moment>
                                      </p>
                                    )}
                                  </span>
                                </h5>
                              </a>
                            </div>
                            <div
                              id={"collapseUnfiled" + i}
                              className="collapse show"
                              role="tabpanel"
                              aria-labelledby={"headingUnfiled" + i}
                              data-parent={"#card" + i}
                            >
                              <div className="card-body">
                                <React.Fragment>
                                  <div
                                    className="row justify-content-center"
                                    style={{
                                      display: "block",
                                      margin: "auto",
                                      width: "100%"
                                    }}
                                  >
                                    <div className="col s12">
                                      {movements.length > 0 ? (
                                        <React.Fragment>
                                          <table className="table table-responsive table-sm table-hover">
                                            <thead>
                                              <tr>
                                                <th scope="col">
                                                  ID Movimentação
                                                </th>
                                                <th scope="col">Remetente</th>
                                                <th scope="col">
                                                  Destinatário
                                                </th>
                                                <th scope="col">Modificado</th>
                                                <th scope="col">Horário</th>
                                                <th scope="col">ID Item</th>
                                                <th scope="col">Tipo</th>
                                                <th scope="col">Descrição</th>
                                                <th scope="col">
                                                  Código/Patrimônio
                                                </th>
                                                <th scope="col">Observação</th>
                                                <th scope="col">
                                                  <i>Status</i>
                                                </th>
                                                <th scope="col">Ações</th>
                                                <th scope="col">
                                                  <input
                                                    disabled={
                                                      transaction.status ===
                                                      "concluida"
                                                        ? true
                                                        : false
                                                    }
                                                    defaultChecked={false}
                                                    type="checkbox"
                                                    id={
                                                      "status" +
                                                      checkboxIdSameTransaction
                                                    }
                                                    onChange={e =>
                                                      this.selectAllMovements(
                                                        e,
                                                        transaction
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    htmlFor={
                                                      "status" +
                                                      checkboxIdSameTransaction
                                                    }
                                                  />
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {movements
                                                .filter(
                                                  movement =>
                                                    movement.id_transacao ===
                                                    transaction.id_transacao
                                                )
                                                .map((movement, j) =>
                                                  movement.status ===
                                                  "ativa" ? (
                                                    <tr key={j}>
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {
                                                          movement.id_movimentacao
                                                        }
                                                      </td>
                                                      {employees.length > 0 &&
                                                        employees
                                                          .filter(
                                                            employee =>
                                                              employee.id ===
                                                              movement.id_remetente
                                                          )
                                                          .map(
                                                            (employee, l) => (
                                                              <td key={l}>
                                                                {employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )}
                                                              </td>
                                                            )
                                                          )}
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <Moment format="DD/MM/YYYY">
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td>
                                                        <Moment
                                                          add={{ hours: 3 }}
                                                          format="HH:mm:ss"
                                                        >
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      {items.length > 0 &&
                                                        items
                                                          .filter(
                                                            item =>
                                                              item.id_movimentacao ===
                                                              movement.id_movimentacao
                                                          )
                                                          .map((item, k) => (
                                                            <React.Fragment
                                                              key={k}
                                                            >
                                                              <td
                                                                style={{
                                                                  fontWeight:
                                                                    "bolder"
                                                                }}
                                                              >
                                                                {item.id_item}
                                                              </td>
                                                              <td>
                                                                {item.tipo.toUpperCase()}
                                                              </td>
                                                              <td>
                                                                {item.descricao &&
                                                                  (item
                                                                    .descricao
                                                                    .length <=
                                                                  15 ? (
                                                                    item.descricao
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_descricao"
                                                                      maxLength="100"
                                                                      value={
                                                                        item.descricao
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  ))}
                                                              </td>
                                                              <td>
                                                                {item.patrimonio ? (
                                                                  item
                                                                    .patrimonio
                                                                    .length <=
                                                                  15 ? (
                                                                    item.patrimonio
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_patrimonio"
                                                                      maxLength="30"
                                                                      value={
                                                                        item.patrimonio
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  )
                                                                ) : (
                                                                  "----"
                                                                )}
                                                              </td>
                                                              <td>
                                                                {item.observacao ? (
                                                                  item
                                                                    .observacao
                                                                    .length <=
                                                                  15 ? (
                                                                    item.observacao
                                                                  ) : (
                                                                    <textarea
                                                                      style={{
                                                                        border:
                                                                          "none"
                                                                      }}
                                                                      className="form-control white"
                                                                      id="view_observacao"
                                                                      maxLength="1000"
                                                                      value={
                                                                        item.observacao
                                                                      }
                                                                      readOnly
                                                                    />
                                                                  )
                                                                ) : (
                                                                  "----"
                                                                )}
                                                              </td>
                                                              <td>
                                                                {statusItem
                                                                  .filter(
                                                                    status =>
                                                                      status.id_status ===
                                                                      item.status
                                                                  )
                                                                  .map(
                                                                    (
                                                                      status,
                                                                      l
                                                                    ) => (
                                                                      <i
                                                                        key={l}
                                                                        style={
                                                                          item.status ===
                                                                          4
                                                                            ? {
                                                                                color:
                                                                                  "red"
                                                                              }
                                                                            : item.status ===
                                                                              3
                                                                            ? {
                                                                                color:
                                                                                  "green"
                                                                              }
                                                                            : item.status ===
                                                                              2
                                                                            ? {
                                                                                color:
                                                                                  "tomato"
                                                                              }
                                                                            : item.status ===
                                                                              1
                                                                            ? {
                                                                                color:
                                                                                  "#357ae8"
                                                                              }
                                                                            : {
                                                                                color:
                                                                                  "black"
                                                                              }
                                                                        }
                                                                      >
                                                                        {status.status.toUpperCase()}
                                                                      </i>
                                                                    )
                                                                  )}
                                                              </td>
                                                              <td align="center">
                                                                <MdInput
                                                                  style={{
                                                                    paddingRight:
                                                                      "5px",
                                                                    fontSize:
                                                                      "1.3rem"
                                                                  }}
                                                                  onClick={() =>
                                                                    !transaction.status.includes(
                                                                      "concluida"
                                                                    ) &&
                                                                    this.handleAction(
                                                                      movement
                                                                    )
                                                                  }
                                                                />
                                                                <MdInfo
                                                                  style={{
                                                                    paddingLeft:
                                                                      "5px",
                                                                    fontSize:
                                                                      "1.3rem"
                                                                  }}
                                                                  onClick={() =>
                                                                    showInfo(
                                                                      item
                                                                    )
                                                                  }
                                                                />
                                                              </td>
                                                              {item.status !==
                                                                5 &&
                                                              item.status !==
                                                                4 ? (
                                                                <td align="center">
                                                                  <input
                                                                    disabled={
                                                                      filter ===
                                                                      "requester"
                                                                        ? item.status !==
                                                                            5 &&
                                                                          item.status !==
                                                                            4
                                                                          ? false
                                                                          : true
                                                                        : item.status !==
                                                                          5
                                                                        ? false
                                                                        : true
                                                                    }
                                                                    defaultChecked={
                                                                      false
                                                                    }
                                                                    type="checkbox"
                                                                    id={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                    onChange={e =>
                                                                      this.selectMovements(
                                                                        e,
                                                                        item,
                                                                        movement,
                                                                        transaction
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    htmlFor={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                  />
                                                                </td>
                                                              ) : (
                                                                <td align="center">
                                                                  <input
                                                                    disabled={
                                                                      true
                                                                    }
                                                                    defaultChecked={
                                                                      false
                                                                    }
                                                                    type="checkbox"
                                                                    id={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                    onChange={e =>
                                                                      this.selectMovements(
                                                                        e,
                                                                        item,
                                                                        movement,
                                                                        transaction
                                                                      )
                                                                    }
                                                                  />
                                                                  <label
                                                                    htmlFor={
                                                                      "status" +
                                                                      checkboxIdSameTransaction +
                                                                      j
                                                                    }
                                                                  />
                                                                </td>
                                                              )}
                                                            </React.Fragment>
                                                          ))}
                                                    </tr>
                                                  ) : (
                                                    <tr
                                                      key={j}
                                                      style={{
                                                        backgroundColor:
                                                          "#fafafa"
                                                      }}
                                                    >
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {
                                                          movement.id_movimentacao
                                                        }
                                                      </td>
                                                      {employees.length > 0 &&
                                                        employees
                                                          .filter(
                                                            employee =>
                                                              employee.id ===
                                                              movement.id_remetente
                                                          )
                                                          .map(
                                                            (employee, l) => (
                                                              <td key={l}>
                                                                {employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )}
                                                              </td>
                                                            )
                                                          )}
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <Moment format="DD/MM/YYYY">
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td>
                                                        <Moment
                                                          add={{ hours: 3 }}
                                                          format="HH:mm:ss"
                                                        >
                                                          {movement.updated_at}
                                                        </Moment>
                                                      </td>
                                                      <td
                                                        style={{
                                                          fontWeight: "bolder"
                                                        }}
                                                      >
                                                        {movement.id_item}
                                                      </td>
                                                      <td>
                                                        <i>Interceptado por:</i>
                                                      </td>
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_interceptador
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <i>
                                                          Novo destinatário:
                                                        </i>
                                                      </td>
                                                      <td>
                                                        {employees.length > 0 &&
                                                          employees
                                                            .filter(
                                                              employee =>
                                                                employee.id ===
                                                                movement.id_novo_destinatario
                                                            )
                                                            .map(employee =>
                                                              employee.usuario
                                                                .toUpperCase()
                                                                .replace(
                                                                  ".",
                                                                  " "
                                                                )
                                                            )}
                                                      </td>
                                                      <td>
                                                        <i>Recebido por: </i>
                                                      </td>
                                                      {movement.id_destinatario_item_recebido ? (
                                                        <td>
                                                          {employees.length >
                                                            0 &&
                                                            employees
                                                              .filter(
                                                                employee =>
                                                                  employee.id ===
                                                                  movement.id_destinatario_item_recebido
                                                              )
                                                              .map(employee =>
                                                                employee.usuario
                                                                  .toUpperCase()
                                                                  .replace(
                                                                    ".",
                                                                    " "
                                                                  )
                                                              )}
                                                        </td>
                                                      ) : (
                                                        <td align="center">
                                                          ----
                                                        </td>
                                                      )}
                                                      <td align="center">
                                                        ----
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                            </tbody>
                                          </table>
                                          <div
                                            className="modal-footer"
                                            style={{
                                              padding: "none",
                                              borderTop: "none",
                                              display: "flex",
                                              WebkitBoxAlign: "center",
                                              justifyContent: "flex-end"
                                            }}
                                          >
                                            {!transaction.status.includes(
                                              "concluida"
                                            ) && (
                                              <React.Fragment>
                                                <div className="row">
                                                  <div
                                                    className="col s6"
                                                    style={{ padding: "5px" }}
                                                  >
                                                    <button
                                                      className="btn btn-secondary"
                                                      onClick={() =>
                                                        this.handleChangeStatusSelectedItems(
                                                          transaction
                                                        )
                                                      }
                                                    >
                                                      Seleção
                                                    </button>
                                                  </div>
                                                  {filter === "requester" && (
                                                    <div
                                                      className="col s6"
                                                      style={{
                                                        padding: "5px"
                                                      }}
                                                      hidden={true}
                                                    >
                                                      <button
                                                        className="btn right"
                                                        onClick={() =>
                                                          this.handleChangeStatusTransaction(
                                                            transaction
                                                          )
                                                        }
                                                        style={
                                                          transaction.status
                                                            .toLowerCase()
                                                            .includes("ativa")
                                                            ? {
                                                                backgroundColor:
                                                                  "#357ae8"
                                                              }
                                                            : transaction.status
                                                                .toLowerCase()
                                                                .includes(
                                                                  "pendente"
                                                                ) && {
                                                                backgroundColor:
                                                                  "#ff6347"
                                                              }
                                                        }
                                                      >
                                                        Concluir
                                                      </button>
                                                    </div>
                                                  )}
                                                </div>
                                              </React.Fragment>
                                            )}
                                          </div>
                                        </React.Fragment>
                                      ) : (
                                        <p style={{ paddingTop: "25px" }}>
                                          Não há novos registros.
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                </React.Fragment>
                              </div>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <p style={{ paddingTop: "25px" }}>
                    Todas transações foram concluídas!
                  </p>
                ))
              ) : (
                <p style={{ paddingTop: "25px" }}>Não há novos registros.</p>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default TransactionsValidation;
